var option_default = {
  "option": "p9kSB",
  "user_choice": "buqs6",
  "check": "mspuX",
  "image": "aEzaq",
  "input": "Gosj3",
  "title": "CVsvu",
  "centered": "oq-7z",
  "with_result": "zvy-x",
  "list": "FKGsN",
  "with_image": "k0fIZ",
  "progress": "y2UQ9",
  "progress_value": "x7aI1",
  "label": "tTBLz",
  "cta": "_0oqOb",
  "adornment_icon": "bZvxI",
  "remove": "IY28R",
  "removeButton": "R7IWH",
  "removeButtonIcon": "_-59-h",
  "overlay": "u07xk",
  "shown": "awHhw",
  "dark": "XNTbi",
  "spinner": "TpuUr",
  "spin": "oJocR"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
